export default __webpack_public_path__ + "static/media/7.7aa49dc6.webp";